var PageSmartupBuy = (function ($) {

    PageSmartupBuy = function (options) {
        var that = this;

        that.class = {
            input: 'input',
            is_active: 'is-active',
            current: 'current',
            disabled: 'disabled',
            muted: 'muted',
            hidden: 'hidden',
            loading: 'loading',
            error: 'error',
            subscription_tab_content: 'js-subscription-tab-content',
            step_wrapper: 'js-step-wrapper',
            confirm_passengers: 'js-confirm-passengers',
            subscriber_fields: 'js-subscriber-fields',
            companions_fields: 'js-companions-fields',
            terms_fields: 'js-terms-fields',
            companions_info_list: 'js-companions-info-list',
            input_birthday: 'js-birthday',
            input_name: 'js-name',
            not_empty: 'not-empty',
            smartup_screen: 'js-smartup-screen',
            confirm_order_modal_title: 'js-modal-header-title'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$order_subscription = that.$wrapper.find('.js-smartup-subscription');
        that.$order_checkout = that.$wrapper.find('.js-smartup-checkout');
        that.$order_payment = that.$wrapper.find('.js-smartup-payment');
        that.$order_frame = that.$wrapper.find('.js-smartup-order-frame');
        that.$companions_available_informer = that.$wrapper.find('.js-companions-available-informer');

        that.$scroll_to = that.$wrapper.find('.js-scroll');

        that.$smartup_step = that.$wrapper.find('.js-smartup-step');
        that.$smartup_step_wrapper = that.$wrapper.find('.js-step-wrapper');
        that.$smartup_screen = that.$wrapper.find('.js-smartup-screen');

        that.$subscription_tab_head = that.$wrapper.find('.js-subscription-tab-heading');
        that.$subscription_tab_content = that.$wrapper.find('.js-subscription-tab-content');

        that.$subscription_subscribe = that.$wrapper.find('.js-subscription-subscribe');
        that.$checkout_subscription = that.$wrapper.find('.js-checkout-subscription');

        that.$input_phone = that.$wrapper.find('.js-phone');
        that.$input_email = that.$wrapper.find('.js-email');
        that.$single_spb_card_input = that.$wrapper.find('.js-single-spb-card');
        that.$single_spb_card_switch = that.$wrapper.find('.js-single-spb-card-switch');
        that.$single_spb_card_submit = that.$wrapper.find('.js-single-spb-card-submit');
        that.$single_spb_card_reset = that.$wrapper.find('.js-single-spb-card-reset');
        that.$single_spb_card_reset_applied = that.$wrapper.find('.js-single-spb-card-reset-applied');
        that.$single_spb_card_form = that.$wrapper.find('.js-single-spb-card-form');
        that.$single_spb_card_applied = that.$wrapper.find('.js-single-spb-card-applied');
        that.$single_spb_card_form_opener = that.$wrapper.find('.js-single-spb-card-form-opener');
        that.$single_spb_card_discount_title = that.$wrapper.find('.js-spb-card-discount-title');

        that.$renewal_not_applicable_info = that.$wrapper.find('.js-renewal-not-applicable-info');
        that.$renewal_applicable_info = that.$wrapper.find('.js-renewal-applicable-info');

        that.$order_title = that.$wrapper.find('.js-order-title');
        that.$order_price = that.$wrapper.find('.js-order-price');
        that.$order_discount_wrapper = that.$wrapper.find('.js-order-discount-wrapper');
        that.$order_discount = that.$wrapper.find('.js-order-discount');
        that.$order_total = that.$wrapper.find('.js-order-total');

        that.$confirm_terms = that.$wrapper.find('.js-confirm-terms');
        that.$confirm_terms_service = that.$wrapper.find('.js-terms-of-service');
        that.$confirm_privacy_policy = that.$wrapper.find('.js-privacy-policy');
        that.$show_confirm_order_modal = that.$wrapper.find('.js-show-confirm-order-modal');
        that.$passengers_form = that.$wrapper.find('.js-passengers-form');

        that.$contact_phone_input = that.$wrapper.find('.js-contact-phone');
        that.$contact_email_input = that.$wrapper.find('.js-contact-email');
        that.$companion_forms_wrapper = that.$wrapper.find('.js-companion-forms');
        that.$checkout_title_with_companions = that.$wrapper.find('.js-smartup-checkout-title-with-companions');
        that.$checkout_title_with_one_companion = that.$wrapper.find('.js-smartup-checkout-title-with-one-companion');
        that.$checkout_title_without_companions = that.$wrapper.find('.js-smartup-checkout-title-without-companions');

        that.companion_form_template = options['templates']['companion_form'];
        that.companion_info_item = options['templates']['companion_info_item'];
        that.confirm_order_modal_content = options['templates']['confirm_order_modal'];
        that.confirm_order_modal_title_single_subscriber = options['locales']['confirm_order_modal_title_single_subscriber'];

        // CONST
        that.discount_code_renewal = 'renewal';
        that.discount_code_single_spb_card = 'single_spb_card';
        that.single_spb_card_length = parseInt(options['single_spb_card_length']);
        that.single_spb_card_prefix = parseInt(options['single_spb_card_prefix']);
        that.subscriptions = options['subscriptions'];

        that.subscriber = options['previous_smartup_order_data']?.subscriber || [];
        that.companions = options['previous_smartup_order_data']?.companions || [];
        that.email = options['previous_smartup_order_data']?.email || null;
        that.phone = options['previous_smartup_order_data']?.phone || null;

        that.applied_discount = options['applied_discount'] || null;
        that.smartup_passenger_form_data_key = 'smartup_passenger_form_data';
        that.smartup_code = options['smartup_code'] || null;
        that.screens = {
            subscriptions: 'smartup-subscriptions',
            checkout: 'smartup-checkout',
        }
        that.is_user_authed = options['is_user_authed'] || false;

        // DYNAMIC VARS
        that.is_locked = false;
        that.proceed_payment_available = true;
        that.selected_subscription = null;
        that.order_data = null;
        that.smartup_order_hash = null;
        that.checkout_result_urls = null;
        that.extra_discounts = null;

        // INIT
        that.init();
    };

    PageSmartupBuy.prototype.init = function () {
        var that = this;

        if (that.is_user_authed) {
            that.__fillFormFromCache();

        } else {
            // если пользователь вышел из аккаунта, то очищаем данные формы из localStorage
            that.__clearFormDataFromCache();
        }

        //
        that.initEventHandlers();
        that.initSingleSpbCardCard();
        that.autoSelectSubscription();
        that.__analyticsEventsOnScreenSwitch();
    };

    PageSmartupBuy.prototype.initPassengersFormInputMasks = function () {
        var that = this,
            $subscriber_fields = that.$passengers_form.find('.' + that.class.subscriber_fields),
            $companions_fields = that.$passengers_form.find('.' + that.class.companions_fields);

        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initEmailMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        that.__initBirthdayMask();

        that.__initNameInputMask($subscriber_fields);
        $companions_fields.each(function () {
            that.__initNameInputMask($(this));
        });
    };

    PageSmartupBuy.prototype.__clearPassengersFormInputErrors = function () {
        var that = this,
            $subscriber_fields = that.$passengers_form.find('.' + that.class.subscriber_fields),
            $companions_fields = that.$passengers_form.find('.' + that.class.companions_fields);

        UIInput.prototype.clearError(that.$confirm_terms);

        UIInput.prototype.clearError($subscriber_fields.find('.' + that.class.input_name));
        UIInput.prototype.clearError($companions_fields.find('.' + that.class.input_name));

        UIInput.prototype.clearError($subscriber_fields.find('.' + that.class.input_birthday));
        UIInput.prototype.clearError($companions_fields.find('.' + that.class.input_birthday));

        UIInput.prototype.clearError(that.$contact_email_input);
        UIInput.prototype.clearError(that.$contact_phone_input);
    }

    PageSmartupBuy.prototype.__initBirthdayMask = function () {
        const that = this,
            $subscriber_birthday = that.$passengers_form.find('.' + that.class.subscriber_fields).find('.' + that.class.input_birthday),
            $companions_birthday = that.$passengers_form.find('.' + that.class.companions_fields).find('.' + that.class.input_birthday);

        // Параметр `mask_inited` необходим для предовращения повторной инициализации маски для поля birthdate подписчика (subscriber)
        if (!$subscriber_birthday.data('mask_inited')) {
            $subscriber_birthday.data('mask_inited', true);

            UIInputMask.prototype.initBirthdayMask($subscriber_birthday);
            $subscriber_birthday.on('blur', function () {
                that.__validateSubscriberBirthday();
            });
        }

        UIInputMask.prototype.initBirthdayMask($companions_birthday);
        $companions_birthday.on('blur', function () {
            var $input = $(this);
            that.__validateCompanionsBirthdays($input);
        });
    };

    PageSmartupBuy.prototype.__initNameInputMask = function ($wrapper) {
        const that = this,
            $inputs_name = $wrapper.find('.' + that.class.input_name);

        $inputs_name.each(function () {
            var $input = $(this),
                input_type = $input.data('type');

            UIInputMask.prototype.initNameInputMask($input, input_type, false);

            $input.on('blur', function () {
                if ($(this).data('required')) {
                    that.__validateField($input);
                }
            });
            $input.on('input', function () {
                that.__validateNameFieldsSum($wrapper);
            });
        });
    };

    PageSmartupBuy.prototype.initEventHandlers = function () {
        const that = this;

        that.$subscription_tab_head.on('click', function () {
            const $tab = $(this),
                tab_id = $tab.attr('data-tab-for');

            that.__switchSubscriptionTab(tab_id);
            that.__switchSubscriptionTabContent(tab_id);
        });

        that.$smartup_step.on('click', function () {
            const $step = $(this),
                screen_id = $step.attr('data-screen-for');

            if ($step.hasClass(that.class.disabled)) {
                return;
            }

            that.__switchSmartupStep(screen_id);
            that.__switchSmartupScreen(screen_id);
        });

        that.$subscription_subscribe.on('click', function () {
            const $subscription = $(this),
                subscription_code = $subscription.data('subscription-code'),
                spb_discount_title = $subscription.data('spb-discount-title');

            that.__selectSubscription(subscription_code);
            that.__changeSpbCardDiscountTitle(spb_discount_title);
        });

        that.$confirm_terms.change(function () {
            const $confirm_term = $(this);

            if (!$confirm_term.is(':checked')) {
                return;
            }
            UIInput.prototype.clearError($confirm_term);
        });

        that.$passengers_form.on('submit', function (e) {
            e.preventDefault();

            if (!that.__checkConfirmCheckboxes()) {
                return;
            }

            var has_form_errors = false;

            const $subscriber_fieldset = that.$passengers_form.find('.' + that.class.subscriber_fields),
                $companions_fieldset = that.$passengers_form.find('.' + that.class.companions_fields);

            if (!that.__validateNames($subscriber_fieldset)) {
                has_form_errors = true;
            }

            let validate_companions = true;
            $companions_fieldset.each(function () {
                const $fieldset = $(this);
                if (!that.__validateNames($fieldset)) {
                    validate_companions = false;
                }
            });
            if (!validate_companions) {
                has_form_errors = true;
            }

            if (!that.__validateEmail()) {
                has_form_errors = true;
            }

            if (!that.__validatePhone()) {
                has_form_errors = true;
            }

            if (!that.__validateBirthdays()) {
                has_form_errors = true;
            }

            if (!that.__validateSingleSpbCardNumber()) {
                that.$single_spb_card_input.focus();
                has_form_errors = true;
            }

            if (has_form_errors) {
                findAndViewError(that.$order_checkout);
                return;
            }

            that.order_data = {
                code: that.selected_subscription['code'],
                subscriber: that.__serializeFields($subscriber_fieldset)[0],
                companions: that.__serializeFields($companions_fieldset),
                terms: {
                    terms_of_service: that.$confirm_terms_service.is(':checked'),
                    privacy_policy: that.$confirm_terms_service.is(':checked'),
                },
                contact_phone: that.$contact_phone_input.val().trim(),
                contact_email: that.$contact_email_input.val().trim(),
                color_scheme: $.sa.is_dark_theme() ? 'dark' : 'light'
            };

            let single_spb_card_id = $.trim(that.$single_spb_card_input.val());
            if (single_spb_card_id.length) {
                that.order_data.single_spb_card = that.single_spb_card_prefix + single_spb_card_id;
            }

            that.__showConfirmOrderInfoModal(that.order_data);
        });

        that.$scroll_to.on('click', function () {
            const scroll_target = $(this).data('scroll-id');
            $.sa.scrollToNode($('#' + scroll_target));
        });

        function findAndViewError($wrapper) {
            const $target = $wrapper.find('.error:visible:first');
            if ($target.length) {
                if ($target.length) {
                    $target[0].scrollIntoView({behavior: "smooth", block: "center"});
                }
            }
        }
    };

    PageSmartupBuy.prototype.__changeSpbCardDiscountTitle = function (title) {
        const that = this;
        that.$single_spb_card_discount_title.text(title);
    };

    /**
     * Сериализовать в массив объектов форму, где есть несколько input-ы с одинаковыми именами. Пример:
     *      subscriber[lastname]
     *      или
     *      companion[0][firstname]
     *      companion[0][firstname]
     *      companion[0][middlename]
     *      companion[0][lastname]
     *      companion[1][firstname]
     *      companion[1][middlename]
     *      companion[1][lastname]
     *
     * @param {array} $fieldsets
     * @returns {*[]}
     * @private
     */
    PageSmartupBuy.prototype.__serializeFields = function ($fieldsets) {
        let results = [];

        $fieldsets.each(function () {
            var fields = {},
                $inputs = $(this).find('input');

            $inputs.each(function () {
                var key = this.name.match(/\[([^\[]*)]$/)[1]; // достать `firstname` из `companion[0][firstname]`
                fields[key] = this.value;
            });

            results.push(fields);
        });

        return results;
    };

    PageSmartupBuy.prototype.__saveCachedFormData = function (form_data) {
        const that = this;
        localStorage.setItem(that.smartup_passenger_form_data_key, JSON.stringify(form_data));
    };

    PageSmartupBuy.prototype.__clearFormDataFromCache = function () {
        const that = this;
        localStorage.removeItem(that.smartup_passenger_form_data_key);
    };

    PageSmartupBuy.prototype.__getCachedFormData = function () {
        const that = this;
        return JSON.parse(localStorage.getItem(that.smartup_passenger_form_data_key)) || null;
    };

    /**
     *  Если есть данные в localStorage, то используем их для заполнения формы пассажиров
     *
     * @private
     */
    PageSmartupBuy.prototype.__fillFormFromCache = function () {
        const that = this,
            passengers_form_data = that.__getCachedFormData();

        // Перезаписываем данные из предыдущей подписки данными из localStorage
        that.subscriber = passengers_form_data?.subscriber || that.subscriber;
        that.companions = passengers_form_data?.companions || that.companions;
        that.email = passengers_form_data?.contact_email || that.email;
        that.phone = passengers_form_data?.contact_phone || that.phone;

       if (that.subscriber) {
           for (let key in that.subscriber) {
               if (!that.subscriber.hasOwnProperty(key)) {
                   continue;
               }
               let value = that.subscriber[key];
               if ('birthdate' === key) {
                   value = that.__reformatDate(value);
               }

               const $input = that.$passengers_form.find(`input[name="subscriber[${key}]"]`);

               $input.val(value).change();
               if ($input.val() && $input.val().length) {
                   $input.parents('.' + that.class.input).addClass(that.class.not_empty);
                   $input.data('input_touched', true);
               }
           }
       }

        if (that.email) {
            that.$contact_email_input.val(that.email);
            that.$contact_email_input.parent().addClass(that.class.not_empty);
        }

        if (that.phone) {
            that.$contact_phone_input.val(that.phone);
            that.$contact_phone_input.parent().addClass(that.class.not_empty);
        }
    };

    PageSmartupBuy.prototype.autoSelectSubscription = function () {
        const that = this;

        if (!that.smartup_code) {
            return;
        }

        that.__selectSubscription(that.smartup_code);
    };

    PageSmartupBuy.prototype.__selectSubscription = function (subscription_code) {
        const that = this,
            screen_id = that.screens.checkout;

        for (let code in that.subscriptions) {
            if (code === subscription_code) {
                that.selected_subscription = that.subscriptions[code];
            }
        }

        that.__renderCompanionForms(that.selected_subscription['params']['companions_count']);
        that.__renderSelectedSubscription(that.selected_subscription['params']['companions_count']);
        that.initPassengersFormInputMasks();

        that.__switchSmartupStep(screen_id);
        that.__switchSmartupScreen(screen_id);

        if (that.__searchExtraDiscounts([that.discount_code_single_spb_card])) {
            UIInput.prototype.clearError(that.$single_spb_card_input);
            that.$single_spb_card_input.val('');
            that.$single_spb_card_applied.hide();
            that.$single_spb_card_form.show();
        }

        that.__clearExtraDiscounts();

        that.__updateOrderPrice();

        that.toggleCompanionsAvailableInformer(that.selected_subscription['params']['companions_count'] > 0);
        that.updateCheckoutTitle(that.selected_subscription['params']['companions_count']);

        that.__analyticsOnSubscriptionSelect(subscription_code);
        that.__analyticsBeginCheckout();
    };

    PageSmartupBuy.prototype.__clearExtraDiscounts = function (exclude_discount_codes = []) {
        const that = this;

        if (!that.extra_discounts || !that.extra_discounts.length) {
            return;
        }

        if (!exclude_discount_codes.length) {
            that.extra_discounts = null;
            return;
        }
        that.extra_discounts = that.extra_discounts.filter(function (discount) {
            return exclude_discount_codes.indexOf(discount['code']) === -1;
        });
    };

    PageSmartupBuy.prototype.__searchExtraDiscounts = function (discount_codes) {
        const that = this;

        if (!that.extra_discounts || !that.extra_discounts.length) {
            return false;
        }

        if (!discount_codes.length) {
            return false;
        }
        return that.extra_discounts.filter(function (discount) {
            return discount_codes.indexOf(discount['code']) !== -1;
        });
    };

    PageSmartupBuy.prototype.initSingleSpbCardCard = function () {
        const that = this,
            href = $.sa.build_url('smartup/buy/spb');

        that.__setSingleSpbCardMask(that.$single_spb_card_input);

        that.$single_spb_card_submit.on('click', function () {
            const single_spb_card = $.trim(that.single_spb_card_prefix + that.$single_spb_card_input.val());

            if (single_spb_card.length !== that.single_spb_card_length) {
                UIInput.prototype.setError(that.$single_spb_card_input);
                return;
            }

            if (that.is_locked) {
                return false;
            }
            that.is_locked = true;

            var data = {
                single_spb_card: single_spb_card,
                subscription_code: that.selected_subscription['code']
            };

            $.sa.buttonLoading(that.$single_spb_card_submit, true);

            $.post(href, data, function (res) {
                if (!res) {
                    res = {
                        status: 'fail',
                        errors: [
                            {
                                code: 0,
                                message: $.sa.locales['something_went_wrong'],
                            }
                        ],
                    };
                }

                switch (res.status) {
                    case 'ok':
                        that.__handleSingleSpbCardSuccess(res);
                        break;
                    case 'fail':
                        that.__handleSingleSpbCardError(res);
                        break;
                }

                that.is_locked = false;
                $.sa.buttonLoading(that.$single_spb_card_submit, false);
            });
        });

        that.$single_spb_card_reset.on('click', function () {
            UIInput.prototype.clearError(that.$single_spb_card_input);
            that.$single_spb_card_input.val('');
            that.$single_spb_card_applied.hide();
            that.$single_spb_card_form.show();
        });

        that.$single_spb_card_reset_applied.on('click', function () {
            const data = {
                subscription_code: that.selected_subscription['code'],
                single_spb_card: that.$single_spb_card_input.val().trim()
            };

            if (!data.single_spb_card) {
                return false;
            }

            that.__resetSingleSpbCardDiscount();
        });
    };

    PageSmartupBuy.prototype.__handleSingleSpbCardSuccess = function (res) {
        const that = this;

        that.extra_discounts = res['data']['discounts'];
        that.__updateOrderPrice(res['data']['discounts']);

        that.$single_spb_card_applied.show();
        that.$single_spb_card_form.hide();
    };

    PageSmartupBuy.prototype.__handleSingleSpbCardError = function (res) {
        const that = this;

        if (res && res['errors'] && res.errors[0] && res.errors[0]['message']) {
            UIInput.prototype.setError(that.$single_spb_card_input, res.errors[0]['message']);
        }

        that.$single_spb_card_applied.hide();
        that.$single_spb_card_form.show();
    }

    PageSmartupBuy.prototype.__resetSingleSpbCardDiscount = function () {
        const that = this;
        that.__clearExtraDiscounts([that.discount_code_single_spb_card]);
        that.__updateOrderPrice();

        UIInput.prototype.clearError(that.$single_spb_card_input);
        that.$single_spb_card_input.val('');
        that.$single_spb_card_applied.hide();
        that.$single_spb_card_form.show();
        that.$single_spb_card_switch.prop('checked', false);
    };

    PageSmartupBuy.prototype.__showConfirmOrderInfoModal = function (order_data) {
        var that = this,
            confirm_order_modal_content = that.confirm_order_modal_content,
            replace_field = '',
            companion_info_item,
            $confirm_order_modal;

        confirm_order_modal_content = confirm_order_modal_content
            .replace('%contact_phone%', order_data.contact_phone)
            .replace('%contact_email%', order_data.contact_email);

        for (var subscriber_field in order_data.subscriber) {
            replace_field = '%' + subscriber_field + '%';
            confirm_order_modal_content = confirm_order_modal_content.replace(replace_field, order_data.subscriber[subscriber_field]);
        }

        $confirm_order_modal = $(confirm_order_modal_content).clone();

        $.uiModal({
            mobile_fullscreen: true,
            disable_content_scroll: false,
            $wrapper: $confirm_order_modal,
            onOpen: function ($modal_wrapper, modal) {
                if (!order_data.companions.length) {
                    $modal_wrapper
                        .find('.' + that.class.confirm_order_modal_title)
                        .text(that.confirm_order_modal_title_single_subscriber);
                }

                for (var companion_index in order_data.companions) {
                    companion_info_item = that.companion_info_item;

                    for (var field in order_data.companions[companion_index]) {
                        replace_field = '%' + field + '%';
                        companion_info_item = companion_info_item.replace(replace_field, order_data.companions[companion_index][field]);
                    }

                    $modal_wrapper.find('.' + that.class.companions_info_list).append(companion_info_item);
                }

                $modal_wrapper.find('.' + that.class.confirm_passengers).on('click', function () {
                    var $confirm_button = $(this),
                        callback = function () {
                            that.$smartup_step_wrapper.addClass(that.class.disabled);
                            that.$smartup_step.addClass(that.class.disabled);
                            $.sa.scrollToNode(that.$wrapper);
                            modal.close();
                        };

                    that.__saveCachedFormData(that.order_data);
                    $.sa.buttonLoading($confirm_button, true);
                    that.__processPayment(callback);
                });

                // добавить для красоты маску для блока, в котором выводится телефон (нередактируемое поле)
                UIInputMask.prototype.initPhoneMask($modal_wrapper);
            }
        });
    };

    PageSmartupBuy.prototype.__renderCompanionForms = function (companions_count) {
        var that = this,
            index_needle = '%index%',
            index_title_needle = '%index_title%',

            lastname_value = '%lastname_value%',
            firstname_value = '%firstname_value%',
            middlename_value = '%middlename_value%',
            birthdate_value = '%birthdate_value%',

            lastname_input_class = '%lastname_input_class%',
            firstname_input_class = '%firstname_input_class%',
            middlename_input_class = '%middlename_input_class%',
            birthdate_input_class = '%birthdate_input_class%',
            index_title = '',
            companion_form_template = '',
            companions_form_template = '';

        for (i = 0; i < companions_count; i++) {
            if (companions_count > 1) {
                index_title = i + 1;
            }
            companion_form_template = that.companion_form_template.replaceAll(index_needle, i);
            companion_form_template = companion_form_template.replaceAll(index_title_needle, index_title);

            if (companions_count === that.companions.length) {
                companion_form_template = companion_form_template.replaceAll(lastname_value, that.companions[i]['lastname']);

                companion_form_template = that.__replaceTemplateFields(companion_form_template, lastname_value, lastname_input_class, that.companions[i]['lastname']);
                companion_form_template = that.__replaceTemplateFields(companion_form_template, firstname_value, firstname_input_class, that.companions[i]['firstname']);
                companion_form_template = that.__replaceTemplateFields(companion_form_template, middlename_value, middlename_input_class, that.companions[i]['middlename']);
                companion_form_template = that.__replaceTemplateFields(companion_form_template, birthdate_value, birthdate_input_class, that.__reformatDate(that.companions[i]['birthdate']));
            }

            companion_form_template = companion_form_template.replaceAll(/\%.+?\%/gi, '');

            companions_form_template += companion_form_template;
        }

        that.$companion_forms_wrapper.html(companions_form_template);
    };

    /**
     * Convert YYYY-MM-DD to DD.MM.YYYY
     * @param date
     * @returns {string|*}
     * @private
     */
    PageSmartupBuy.prototype.__reformatDate = function (date) {
        var that = this;
        if (!date || !date.includes('-')) {
            return date;
        }

        var parts = date.split('-');
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
    };

    PageSmartupBuy.prototype.__replaceTemplateFields = function (template, field, input_class, value) {
        var that = this;

        template = template.replaceAll(field, value, value);

        if (value?.length) {
            template = template.replaceAll(input_class, that.class.not_empty);
        } else {
            template = template.replaceAll(input_class, '');
        }
        return template;
    };

    PageSmartupBuy.prototype.__renderSelectedSubscription = function () {
        var that = this;

        that.$checkout_subscription.addClass(that.class.hidden);
        that.$checkout_subscription.filter('[data-subscription-code=' + that.selected_subscription['code'] + ']').removeClass(that.class.hidden);
    };

    PageSmartupBuy.prototype.__switchSmartupStep = function (screen_id) {
        var that = this,
            $steps = that.$smartup_step.filter('[data-screen-for=' + screen_id + ']').parent('.' + that.class.step_wrapper);

        that.$smartup_step_wrapper
            .removeClass(that.class.is_active)
            .removeClass(that.class.current)
            .removeClass(that.class.disabled);

        $steps
            .addClass(that.class.is_active)
            .addClass(that.class.current);

    };

    PageSmartupBuy.prototype.__switchSmartupScreen = function (screen_id) {
        var that = this,
            $screen = that.$wrapper.find('[data-screen-id=' + screen_id + ']');

        that.$smartup_screen.hide();
        $screen.show();
        that.__clearPassengersFormInputErrors();
        that.__analyticsEventsOnScreenSwitch(screen_id);
        //
        $.sa.scrollToNode(that.$wrapper);
    };

    PageSmartupBuy.prototype.__switchSubscriptionTab = function (tab_id) {
        var that = this,
            $tabs = that.$subscription_tab_head.filter('[data-tab-for=' + tab_id + ']');

        that.$subscription_tab_head.removeClass(that.class.is_active);
        $tabs.addClass(that.class.is_active);
    };

    PageSmartupBuy.prototype.__switchSubscriptionTabContent = function (tab_id) {
        var that = this,
            $tabs_content = that.$subscription_tab_content.filter('[data-tab-id=' + tab_id + ']');

        that.$subscription_tab_content.removeClass(that.class.is_active);
        $tabs_content.addClass(that.class.is_active);
    };

    PageSmartupBuy.prototype.__setSingleSpbCardMask = function ($input) {
        var that = this,
            complete = false;

        $input.inputmask({
            mask: that.single_spb_card_prefix + '99 9999 9999 9999',
            inputmode: 'numeric',
            autoUnmask: true,
            placeholder: '_',
            onKeyValidation: function (key, result) {
                if (result || complete === true) {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });

        $input.on('blur', function () {
            var $input = $(this),
                value = $.trim(that.single_spb_card_prefix + $input.val());
            if (value.length !== that.single_spb_card_length) {
                UIInput.prototype.setError($input);
            }
        });
    };

    PageSmartupBuy.prototype.__updateOrderPrice = function (extra_discounts = []) {
        var that = this,
            code = that.selected_subscription['code'],
            amount = parseFloat(that.selected_subscription['price_rub']),
            personal_discounts = that.applied_discount && that.applied_discount[code] ? that.applied_discount[code] : [];

        extra_discounts = extra_discounts || that.extra_discounts || [];

        if (!extra_discounts || !extra_discounts.length) {
            extra_discounts = that.extra_discounts || [];
        }

        var discounts = Array.prototype.concat(
            personal_discounts,
            extra_discounts,
        );

        var available_discounts = {
            sum: discounts
                .filter(function (discount) {
                    return discount.agg == 'sum';
                })
                .reduce(
                    function (discount_sum, discount) {
                        discount_sum.discount_rub += discount.discount_rub;
                        discount_sum.codes.push(discount.code);
                        return discount_sum;
                    },
                    {type: 'sum', discount_rub: 0, codes: []}
                ),

            max: discounts
                .filter(function (discount) {
                    return discount.agg == 'max';
                })
                .reduce(
                    function (discount_max, discount) {
                        if (discount.discount_rub > discount_max.discount_rub) {
                            discount_max.discount_rub = discount.discount_rub;
                            discount_max.codes = [discount.code];
                        }
                        if (discount.discount_rub === discount_max.discount_rub && !discount_max.codes.includes(discount.code)) {
                            // сохраняем персональные коды с одинаковой максимальной скидкой
                            discount_max.codes.push(discount.code);
                        }
                        return discount_max;
                    },
                    {type: 'max', discount_rub: 0, codes: []}
                )
        };

        var is_max_discount_type = available_discounts.max.discount_rub > available_discounts.sum.discount_rub;
        var total_discount = is_max_discount_type
            ? available_discounts.max
            : available_discounts.sum;

        var renewal_discount = discounts
            .filter(function (discount) {
                return discount.code === that.discount_code_renewal;
            });

        // Если доступна скидка при продлении, то показываем/скрываем соответствующие блоки-предупреждения
        if (renewal_discount.length) {
            /* Получаем список персональных кодов */
            var personal_codes = personal_discounts.map(function (personal_discount) {
                return personal_discount.code;
            });

            /* Получаем список использованных в скидке персональных кодов */
            var used_personal_codes = total_discount.codes.filter(function (code) {
                return personal_codes.includes(code);
            });

            if (used_personal_codes.length && (is_max_discount_type && total_discount.codes.length === 1)) {
                that.__toggleDiscountApplicableBlocks(true);
            } else {
                that.__toggleDiscountApplicableBlocks(false);
            }
        }


        var total = amount - total_discount.discount_rub;
        that.active_discounts = total_discount.discount_rub > 0 ? total_discount : null;

        that.$order_price.text(amount.toFixed(2));
        that.$order_discount.text(total_discount.discount_rub.toFixed(2));
        that.$order_total.text(total.toFixed(2));

        that.$order_discount_wrapper.toggle(total_discount.discount_rub > 0);
    };

    PageSmartupBuy.prototype.__toggleDiscountApplicableBlocks = function (is_applied = true) {
        var that = this;
        if (is_applied) {
            that.$renewal_applicable_info.removeClass(that.class.hidden);
            that.$renewal_not_applicable_info.addClass(that.class.hidden);
        } else {
            that.$renewal_applicable_info.addClass(that.class.hidden);
            that.$renewal_not_applicable_info.removeClass(that.class.hidden);
        }
    };

    PageSmartupBuy.prototype.__checkConfirmCheckboxes = function () {
        var that = this,
            error = false;

        that.$confirm_terms.each(function () {
            var $confirm_term = $(this);

            if (!$confirm_term.is(':checked')) {
                UIInput.prototype.setError($confirm_term);
                error = true;
                return false;
            }
            UIInput.prototype.clearError($confirm_term);
        });

        return !error;
    };

    PageSmartupBuy.prototype.__processPayment = function (callback = null) {
        var that = this,
            href = $.sa.build_url('smartup/buy/payment');

        var data = that.order_data;

        if (that.is_locked) {
            return false;
        }
        that.is_locked = true;

        $.post(href, data, function (res) {
            if (callback && typeof callback === 'function') {
                callback();
            }

            if (!res) {
                res = {
                    status: 'fail',
                    errors: [
                        {
                            code: 0,
                            message: $.sa.locales['something_went_wrong'],
                        }
                    ],
                };
            }

            switch (res.status) {
                case 'ok':
                    that.__handleProceedPaymentSuccess(res);
                    break;
                case 'fail':
                    that.__handleProceedPaymentError(res);
                    break;
            }

            that.is_locked = false;
        });
    };

    PageSmartupBuy.prototype.__handleProceedPaymentSuccess = function (res) {
        var that = this;

        that.smartup_order_hash = res.data['smartup_order_hash'];
        that.checkout_result_urls = res.data['checkout_result_urls'];
        that.initPaymentStatusChecker();
        that.constructEventListener();
        that.togglePaymentFrame();
        that.$order_frame.html(res.data['payment_data']);

        that.__analyticsAddPaymentInfo();

        //
        $.sa.scrollToNode(that.$wrapper);
    };

    PageSmartupBuy.prototype.__handleProceedPaymentError = function (res) {
        $.each(res.errors, function (i, error) {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-circle-x"></i>',
                header_title: $.sa.locales['error'],
                content: error.message,
                button_cancel_text: $.sa.locales['close']
            });
        });
    };

    PageSmartupBuy.prototype.__validateSingleSpbCardNumber = function () {
        var that = this,
            value = $.trim(that.single_spb_card_prefix + that.$single_spb_card_input.val());

        if (value.length > 0 && that.$single_spb_card_input.parent().hasClass(that.class.error)) {
            return false;
        }

        return true;
    }

    PageSmartupBuy.prototype.__validateNames = function ($wrapper) {
        var that = this,
            $inputs_name = $wrapper.find('.' + that.class.input_name),
            validated = true;

        $inputs_name.each(function () {
            var $input = $(this);
            if ($input.data('required') && !that.__validateField($input)) {
                validated = false;
            }
        });

        if (!validated) {
            return validated;
        }

        if (!that.__validateNameFieldsSum($wrapper)) {
            validated = false;
        }

        return validated;
    };

    PageSmartupBuy.prototype.__validateBirthdays = function () {
        var that = this;

        return that.__validateSubscriberBirthday() && that.__validateCompanionsBirthdays();
    };

    PageSmartupBuy.prototype.__validateSubscriberBirthday = function () {
        var that = this,
            $subscriber_birthday = that.$passengers_form.find('.' + that.class.subscriber_fields).find('.' + that.class.input_birthday),
            subscriber_birthday_formatted = dayjs($subscriber_birthday.val().trim(), 'DD.MM.YYYY', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            subscriber_age = datetime_now.diff(subscriber_birthday_formatted, 'year', true),
            error_subscriber_min_age = $subscriber_birthday.data('error-min-age');

        if (!that.__validateBirthday($subscriber_birthday)) {
            UIInput.prototype.setError($subscriber_birthday);
            return false;
        }

        if (subscriber_age < 18) {
            UIInput.prototype.setError($subscriber_birthday, error_subscriber_min_age);
            return false;
        }
        return true;
    };

    PageSmartupBuy.prototype.__validateCompanionsBirthdays = function ($companion_input = null) {
        var that = this,
            $subscriber_birthday = that.$passengers_form.find('.' + that.class.subscriber_fields).find('.' + that.class.input_birthday),
            $companions_birthdays = $companion_input || that.$passengers_form.find('.' + that.class.companions_fields).find('.' + that.class.input_birthday),
            subscriber_birthday_formatted = dayjs($subscriber_birthday.val().trim(), 'DD.MM.YYYY', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            subscriber_age = datetime_now.diff(subscriber_birthday_formatted, 'year', true);

        // если день рождения Подписчика невалидный,
        // то не проверяем дни рождения Попутчиков
        if (!that.__validateSubscriberBirthday()) {
            return true;
        }

        var companions_validate_error = false;

        $companions_birthdays.each(function () {
            var $companion_birthday = $(this),
                companion_birthday_formatted = dayjs($companion_birthday.val().trim(), 'DD.MM.YYYY', true),
                companion_age = datetime_now.diff(companion_birthday_formatted, 'year', true),
                error_companion_min_age = $companion_birthday.data('error-min-age');

            if (!that.__validateBirthday($companion_birthday)) {
                UIInput.prototype.setError($companion_birthday);
                companions_validate_error = true;
                return;
            }

            if (subscriber_age < 18 && companion_age < 2) {
                UIInput.prototype.setError($companion_birthday, error_companion_min_age);
                companions_validate_error = true;
            }
        });

        return !companions_validate_error;
    };

    PageSmartupBuy.prototype.__validateBirthday = function ($input) {
        var birthday = $input.val().trim();
        return UIInputMask.prototype.validateBirthday(birthday);
    };

    PageSmartupBuy.prototype.__validateField = function ($input) {
        var that = this,
            value = $input.val(),
            error_empty = $input.data('error-empty'),
            value_trim = value.replace(/[- _]/g, ''),
            validated = true;

        if (!$input.data('set-error')) {
            UIInput.prototype.clearError($input);
        }

        if ($input.prop('disabled')) {
            return true;
        }

        if (value_trim.length < 1) {
            UIInput.prototype.setError($input, error_empty, true);
            validated = false;
        }

        return validated;
    };

    PageSmartupBuy.prototype.__validateEmail = function () {
        var that = this,
            $input = that.$input_email,
            result = $.trim($input.val()),
            required = $input.data('required'),
            error_empty = $input.data('error-empty'),
            error_invalid = $input.data('error-invalid');

        UIInput.prototype.clearError($input);

        if (!result && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !$.sa.validate.email(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    PageSmartupBuy.prototype.__validatePhone = function () {
        var that = this,
            $input = that.$input_phone,
            result = $.trim($input.val()),
            required = $input.data('required'),
            error_empty = $input.data('error-empty'),
            error_invalid = $input.data('error-invalid');

        UIInput.prototype.clearError($input);

        if (!result && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !UIInputMask.prototype.__validatePhone(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    PageSmartupBuy.prototype.__validateNameFieldsSum = function ($wrapper) {
        var that = this,
            $inputs_name = $wrapper.find('.js-name'),
            $alert_wrapper = $wrapper.find('.js-alert-limit-characters'),
            is_valid = UIInputMask.prototype.validateNameFieldsLength($wrapper);

        that.__alertClose($alert_wrapper);

        $inputs_name.each(function () {
            var $input = $(this),
                error_text = $input.data('limit-characters');

            if ($input.val().length > 0) {
                if (!is_valid) {
                    UIInput.prototype.setError($input, error_text, true);
                    $input.data('set-error', true);
                    that.__alertShow($alert_wrapper);
                } else {
                    if (!$input.data('set-error-masks')) {
                        UIInput.prototype.clearError($input);
                        $input.data('set-error', false);
                    }
                }
            }
        });

        return is_valid;
    };

    PageSmartupBuy.prototype.__alertShow = function ($alert_wrapper) {
        $alert_wrapper.show();
    };

    PageSmartupBuy.prototype.__alertClose = function ($alert_wrapper) {
        $alert_wrapper.hide();
    };

    PageSmartupBuy.prototype.initPaymentStatusChecker = function () {
        var that = this,
            smartup_status = null,
            href = $.sa.build_url('smartup/buy/status'),
            data = {
                smartup_order_hash: that.smartup_order_hash,
            };

        var success_statuses = [
                'paid',
                'issue_processing',
                'issue_processing_failure',
                'issued',
            ],
            fail_statuses = [
                'void',
                'canceled'
            ];

        var counter = 0,
            is_locked = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }

                if (!that.$order_frame.is(':visible')) {
                    clearInterval(timer);
                    if (window.removeEventListener) {
                        window.removeEventListener('message', that.dispatchEventMessage);
                    }
                    return;
                }

                if (counter >= 240) {
                    clearInterval(timer);
                } else {
                    is_locked = true;

                    $.post(href, data, function (res) {
                        if (res && res.data) {
                            if (res.data.status) {
                                smartup_status = res.data.status;
                            }

                            if (res.data.status === false) {
                                clearInterval(timer);
                                window.location.reload();
                            }
                        }

                        if ($.inArray(smartup_status, success_statuses) !== -1) {
                            clearInterval(timer);
                            if (smartup_status === 'issue_processing_failure') {
                                $.sa.content_router.load(that.checkout_result_urls['fail']);
                            } else if (window.location.href !== that.checkout_result_urls['success']) {
                                $.sa.content_router.load(that.checkout_result_urls['success']);
                            }
                        } else if ($.inArray(smartup_status, fail_statuses) !== -1) {
                            clearInterval(timer);
                            $.sa.content_router.load(that.checkout_result_urls['fail']);
                        }
                        is_locked = false;
                    });
                    counter++;
                }
            }, 1500);
    };

    PageSmartupBuy.prototype.constructEventListener = function () {
        var that = this;

        if (window.addEventListener) {
            window.addEventListener('message', that.dispatchEventMessage, false);
        } else {
            console.log('postMessages not supported: https://developer.mozilla.org/ru/docs/Web/API/Window/postMessage');
        }
    };

    PageSmartupBuy.prototype.dispatchEventMessage = function (event) {
        var that = this,
            data = event.data;
        if (!data.length) {
            return false;
        }
        if (typeof event.data === 'string') {
            data = JSON.parse(event.data);
        }

        if (data.message_source && data.message_source === 'avia') {
            $.sa.log('Avia app event', data);
        } else {
            return false;
        }

        switch (data.type) {
            case 'retry_checkout':
                if (window.removeEventListener) {
                    window.removeEventListener('message', that.dispatchEventMessage);
                }
                window.location.reload();
                break;
        }
    };

    PageSmartupBuy.prototype.togglePaymentFrame = function (show = true) {
        var that = this,
            screen_id = 'smartup-payment';

        that.__switchSmartupScreen(screen_id);
    };

    PageSmartupBuy.prototype.toggleCompanionsAvailableInformer = function (show = true) {
        var that = this;

        that.$companions_available_informer.toggleClass(that.class.hidden, !show);
    };

    PageSmartupBuy.prototype.updateCheckoutTitle = function (companions_count = 0) {
        var that = this;

        switch (companions_count) {
            case 0:
                that.$checkout_title_without_companions.toggleClass(that.class.hidden, false);
                that.$checkout_title_with_one_companion.toggleClass(that.class.hidden, true);
                that.$checkout_title_with_companions.toggleClass(that.class.hidden, true);
                break;
            case 1:
                that.$checkout_title_without_companions.toggleClass(that.class.hidden, true);
                that.$checkout_title_with_one_companion.toggleClass(that.class.hidden, false);
                that.$checkout_title_with_companions.toggleClass(that.class.hidden, true);
                break;
            default:
                that.$checkout_title_without_companions.toggleClass(that.class.hidden, true);
                that.$checkout_title_with_one_companion.toggleClass(that.class.hidden, true);
                that.$checkout_title_with_companions.toggleClass(that.class.hidden, false);
                break;
        }
    };

    /**
     * @param {string} [code]
     * @param {boolean} [promotion]
     * @return {object[]|null}
     * @private
     */
    PageSmartupBuy.prototype.__getAnalyticsItems = function (code, promotion) {
        const that = this,
            buildItem = subscription_code => {
                if (!that.subscriptions[subscription_code]) return null;
                const res = {
                    item_name: that.subscriptions[subscription_code].name,
                    item_id: that.subscriptions[subscription_code].id,
                    price: Math.round(parseFloat(that.subscriptions[subscription_code].price_rub) * 100) / 100,
                    item_category: that.subscriptions[subscription_code].code,
                    currency: 'RUB',
                    quantity: 1
                };
                if (promotion && code && that.active_discounts) {
                    Object.assign(res, {
                        discount: Math.round(that.active_discounts.discount_rub * 100) / 100
                    });
                }
                return res;
            };

        if (code) {
            if (that.subscriptions[code]) {
                return [buildItem(code)];
            }
            return null;
        }

        const items = [];
        Object.keys(that.subscriptions).forEach(key => items.push(buildItem(key)));

        return items;
    }

    /**
     * @return {jQuery|null}
     * @private
     */
    PageSmartupBuy.prototype.__getCurrentSmartupScreen = function () {
        const that = this,
            $current_screen = that.$wrapper.find(`.${that.class.smartup_screen}:visible`).first();

        return $current_screen.length ? $current_screen : null;
    }

    /**
     * Отправка событий при переключении экранов оформления подписки
     *
     * @param {string} [screen_id]
     * @private
     */
    PageSmartupBuy.prototype.__analyticsEventsOnScreenSwitch = function (screen_id) {
        const that = this;
        let $current_screen;

        if (screen_id) {
            $current_screen = $(that.$wrapper.find(`.${that.class.smartup_screen}[data-screen-id='${screen_id}']`)).first();
            if (!$current_screen.length) {
                return;
            }
        } else {
            $current_screen = that.__getCurrentSmartupScreen();
            if (!$current_screen.length) return;
            screen_id = $current_screen.data('screen-id');
            if (!screen_id) {
                return;
            }
        }

        that.__analyticsSelectContent($current_screen);

        switch (screen_id) {
            case 'smartup-subscriptions':
                that.__analyticsSendSubscriptionsList();
                break;
        }
    }

    /**
     * Отправка события GA select_content при открытии любого экрана оформления подписки
     *
     * @param {jQuery} [$current_screen]
     * @private
     */
    PageSmartupBuy.prototype.__analyticsSelectContent = function ($current_screen) {
        const that = this;

        if (!$current_screen) {
            $current_screen = that.__getCurrentSmartupScreen();
        }

        if (!$current_screen) {
            return;
        }

        const select_content_item_id = $current_screen.data('analytics-content');
        if (!select_content_item_id) {
            return;
        }

        $.sa.analytics.gtagSelectContent('page', select_content_item_id);
    }

    /**
     * Отправляет событие select_item при выборе подписки для оформления
     *
     * @param {string} code Код подписки, например 'smartup_1_1'
     * @private
     */
    PageSmartupBuy.prototype.__analyticsOnSubscriptionSelect = function (code) {
        var that = this, items;

        if (!code) {
            return;
        }

        items = that.__getAnalyticsItems(code);
        if (!items) {
            return;
        }

        $.sa.analytics.gtag('event', 'select_item', {item_list_id: 'smartup_subscriptions', items: items});
    }

    PageSmartupBuy.prototype.__analyticsBeginCheckout = function () {
        var that = this,
            items = that.__getAnalyticsItems(that.selected_subscription.code);
        if (!items) {
            return;
        }

        $.sa.analytics.gtag('event', 'begin_checkout', {
            currency: 'RUB',
            value: Math.round(items.reduce((acc, item) => acc + item.price * item.quantity - (item.discount || 0) * item.quantity, 0.0) * 100) / 100,
            items: items
        });
    }

    PageSmartupBuy.prototype.__analyticsAddPaymentInfo = function () {
        var that = this,
            items = that.__getAnalyticsItems(that.selected_subscription.code, true);
        if (!items) {
            return;
        }

        $.sa.analytics.gtag('event', 'add_payment_info', {
            currency: 'RUB',
            value: Math.round(items.reduce((acc, item) => acc + item.price * item.quantity - (item.discount || 0) * item.quantity, 0.0) * 100) / 100,
            items: items
        });
    }

    /**
     * Отправляет событие аналитики view_item_list при открытии экрана со списком подписок
     *
     * @private
     */
    PageSmartupBuy.prototype.__analyticsSendSubscriptionsList = function () {
        var that = this;
        $.sa.analytics.gtag('event', 'view_item_list', {
            item_list_id: 'smartup_subscriptions',
            items: that.__getAnalyticsItems()
        });
    }

    return PageSmartupBuy;
})($);
